import type { InjectionKey } from 'vue';
import type { HttpClient, Api } from '@shopexperts/legacy-api';

/**
 * Vue InjectionKey for the HttpClient.
 * Use with Vue's provide/inject API.
 */
export const HttpClientKey: InjectionKey<HttpClient> = Symbol('HttpClient');

/**
 * Vue InjectionKey for the Api instance.
 * Use with Vue's provide/inject API.
 */
export const ApiKey: InjectionKey<Api> = Symbol('Api');